import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatTableDataSource} from "@angular/material/table";
import {ActionPointsService} from "../../../../service/club-gigot/action-points.service";
import {
    DialogAddProductGroupComponent,
    DialogData
} from "../dialog-add-product-group/dialog-add-product-group.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BehaviorSubject} from "rxjs";
import {
    ActionPointsAdvanceSaleResult
} from "../../../../model/club-gigot/action-points/action-points-advance-sale-result.model";
import {
    ActionPointsDTO,
    AdvanceSaleGroupProduct
} from "../../../../model/club-gigot/action-points/action-points-configuration.model";
import {ActionPointType} from "../../../../model/club-gigot/action-points/_enum/action-point.enum";
import {SaveActionPointsDTO} from "../../../../model/club-gigot/action-points/save-action-point.model";
import {finalize} from "rxjs/operators";

@Component({
  selector: "kt-dialog-advance-sale-configuration",
  templateUrl: "./dialog-advance-sale.component.html",
  styleUrls: ["./dialog-advance-sale.component.scss"]
})
export class DialogAdvanceSaleComponent implements OnInit {

    public advancedSaleGroupForm: FormGroup;
    public isEditMode = false;
    public tableDataSource: MatTableDataSource<any>;
    public maxDurationCampaign: number = 40;
    public maxExpirationCampaign: number = 40;
    public maxCampaignsToNet: number = 50;


    constructor(private dialogRef: MatDialogRef<DialogAddProductGroupComponent>,
                private actionPointsService: ActionPointsService,
                private cdr: ChangeDetectorRef,
                @Inject (MAT_DIALOG_DATA)
                public data: DialogData) { }

    ngOnInit() {
        this.buildForms();
    }

    public buildForms(){
        this.advancedSaleGroupForm = new FormGroup({
            id : new FormControl((this.isEditMode && this.data.actionPointData !== undefined) ? this.data.actionPointData.id : null),
            name : new FormControl(this.isEditMode ? this.data.actionPointData.name : null, [Validators.required]),
            campaignsToNet: new FormControl(this.isEditMode ? this.data.actionPointData.campaignsToNet.toString() : null, [Validators.required]),
            endingCampaignSequence: new FormControl(this.isEditMode ? this.data.actionPointData.endingCampaignSequence.toString() : null, [Validators.required]),
            expirationPointsCampaignSequence: new FormControl(this.isEditMode ? (this.data.actionPointData.expirationPointsCampaignSequence - this.data.campaignSequence).toString() : null, [Validators.required]),
            reachId: new FormControl(this.isEditMode ? this.data.actionPointData.reachId : null)
        });
    }

    public onNoClick(): void {
        this.dialogRef.close(new ActionPointsAdvanceSaleResult(true));
    }

    public onContinue(): void{
    }

    public onReturn(): void{
    }

    public onCreate():void{

        const actionPointDTO = new ActionPointsDTO();
        actionPointDTO.addActionPoint(ActionPointType.AdvanceSale, {
            id: this.advancedSaleGroupForm.controls['id'].value,
            campaignSequence: this.data.campaignSequence,
            name: this.advancedSaleGroupForm.controls['name'].value,
            campaignsToNet: this.advancedSaleGroupForm.controls['campaignsToNet'].value,
            endingCampaignSequence: this.advancedSaleGroupForm.controls['endingCampaignSequence'].value,
            expirationPointsCampaign: this.advancedSaleGroupForm.controls['expirationPointsCampaignSequence'].value,
            reachId: this.advancedSaleGroupForm.controls['reachId'].value,
        });

        const dto = new SaveActionPointsDTO(ActionPointType.AdvanceSale, actionPointDTO);

        this.actionPointsService
            .saveActionPointConfiguration(this.data.campaignSequence, dto, this.isEditMode)
            .pipe(
                finalize(() => {
                })
            )
            .subscribe({
                next: (_ : any) => this.dialogRef.close(new ActionPointsAdvanceSaleResult(false, true, this.data.campaignSequence)),
                error: (error : Error) => this.dialogRef.close(new ActionPointsAdvanceSaleResult(false, false, this.data.campaignSequence, error.message))
            })
    }


    public updateExpiration(newValue: number): void {
        if(this.advancedSaleGroupForm.controls.expirationPointsCampaignSequence.value <= newValue )
            this.advancedSaleGroupForm.controls.expirationPointsCampaignSequence.reset();
    }

    public updateNet(newValue: number): void {
        if(this.advancedSaleGroupForm.controls.campaignsToNet.value <= newValue )
            this.advancedSaleGroupForm.controls.campaignsToNet.reset();
    }

    /**
     * @description
     *	Convierte un string a un numero (para usar desde el html)
     *
     *  @param value - valor numerico como string
     *  @returns el valor como int
     */
    public getNumber(value: string): number{
        return parseInt(value);
    }

}
